export const EMPTY_STATE_MIN_HEIGHT = 'min-h-[60vh]';
